import React, { useMemo } from "react";
import Link from "next/link";
import NavPagesDropdown from "./dropdown/nav-pages-dropdown";
import NavSmMegaMenus from "./dropdown/nav-sm-mega-menus";
import { menu_data, secondary_menu_data } from "@/data/menu-data";
import { ifArabic, getLocalizedPath } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";

type IProps = {
  sm_mega_title?: string;
  transparent?: boolean;
  headerTwo?: boolean;
};

export default function NavMenus({
  sm_mega_title,
  transparent,
  headerTwo,
}: IProps) {
  const { language } = useLanguage();

  const data = useMemo(() => {
    return headerTwo ? secondary_menu_data : menu_data;
  }, [headerTwo]);

  return (
    <nav className="tp-main-menu-content d-flex justify-content-end">
      <ul>
        {data.map((menu) => (
          <li
            key={menu.id}
            className={`${menu.noDropdown ? "" : "has-dropdown"}  ${
              menu.home_dropdown || (menu.pages_dropdown && !menu?.academics)
                ? "tp-static"
                : ""
            }`}
          >
            <Link
              aria-label={menu.title}
              href={getLocalizedPath(menu.link || "#", language)}
              className={`${transparent ? "" : "navbar-link"}`}
            >
              {menu.sm_mega_menus && sm_mega_title
                ? sm_mega_title
                : ifArabic(menu.titleAr, menu.title)}
            </Link>
            {/* {menu.home_dropdown && (
              <div className="tp-megamenu-main tp-megamenu-container">
                <NavHomeDropdown home_dropdown={menu.home_dropdown} />
              </div>
            )} */}
            {menu.sm_mega_menus && (
              <div className="tp-megamenu-main tp-megamenu-small">
                <NavSmMegaMenus
                  dropdown_menus={menu.sm_mega_menus}
                  academics={menu.academics}
                />
              </div>
            )}
            {menu.pages_dropdown && !menu?.academics && (
              <div className="tp-megamenu-main tp-megamenu-fullwidth">
                <NavPagesDropdown pages_dropdown={menu.pages_dropdown} />
              </div>
            )}
            {menu.dropdown_menus && (
              <ul className="tp-submenu">
                {menu.dropdown_menus.map((dm) => (
                  <li key={dm.id}>
                    <Link
                      aria-label={dm.title}
                      href={getLocalizedPath(dm.link || "#", language)}
                      target={dm.target}
                    >
                      {ifArabic(dm.titleAr, dm.title)}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
